<template>
  <div>
    <el-dialog :visible.sync="selfDialogVisible" :before-close="beforeClose">
      <div
        style="
          width: 100%;
          height: 40px;
          background: #409eff;
          line-height: 40px;
          font-size: 16px;
          font-weight: blod;
          color: #ffffff;
        "
      >
        <span>
          <i class="el-icon-arrow-left"></i>
          <el-link :underline="false" @click="toHome">返回</el-link>
        </span>
      </div>
      <el-main>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="当前账户" style="font-weight: 900">
            <div>
              {{ $store.state.keycloakToken.tokenParsed.preferred_username }}
            </div>
          </el-form-item>
          <el-form-item label="旧密码" prop="oldPass">
            <el-input
              type="password"
              v-model="ruleForm.oldPass"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </el-main>
    </el-dialog>

    <!-- <person-center-info
    :dialogVisible="dialogVisibles"
    @updateDialogVisible="updateDialogVisible"
  >
  </person-center-info> -->
  </div>
</template>

<script>
import api from 'api/module/role'
export default {
  //inject: ['app'],
  props: {
    dialogVisible: {
      type: Boolean,
    },
  },
  components: {},
  computed: {
    selfDialogVisible() {
      return this.dialogVisible
    },
  },
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('年龄不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (value < 18) {
            callback(new Error('必须年满18岁'))
          } else {
            callback()
          }
        }
      }, 1000)
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        oldPass: '',
        pass: '',
        checkPass: '',
        age: '',
      },
      rules: {
        oldPass: [{ validator: validatePass, trigger: 'blur' }],
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
        age: [{ validator: checkAge, trigger: 'blur' }],
      },
      activeName: '1',
      actice: 1,
      dialogVisibles: false,
      // 功能标签
      firstList: [
        {
          name: '个人设置',
          tip: 1,
        },
        {
          name: '系统设置',
          tip: 2,
        },
      ],
      secondList: [
        [
          {
            name: '基本信息',
            component: 'PersonCenterInfo',
            tip: '1',
          },
          {
            name: '三方账户',
            component: 'OtherAccount',
            tip: '2',
          },
          {
            name: '设备绑定',
            component: 'OtherPhone',
            tip: '3',
          },
        ],
        [
          {
            name: '插件管理',
            component: 'PlgUnit',
            tip: '1',
          },
        ],
      ],
      listnum: 0,
    }
  },
  created() {},
  mounted() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api({
            name: 'editPwd',
            data: {
              oldPwd: this.ruleForm.oldPass,
              pwd: this.ruleForm.pass,
              loginName:
                this.$store.state.keycloakToken.tokenParsed.preferred_username,
            },
            _this: this,
          }).then((res) => {
            if (res.data.status === 1) {
              this.$message.success('密码修改成功')
              this.$emit('updateDialogVisible')
              parent.postMessage(
                {
                  flag: 'notification',
                  data: {
                    type: 'success',
                    title: '成功',
                    duration: 3000,
                    message: '密码修改成功',
                  },
                },
                '*'
              )
            }
            else{
              this.$message.error(res.data.message)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    changeSet(num) {
      this.listnum = num - 1
    },
    goSet(num) {
      this.activeName = num
    },
    peizhi() {
      this.dialogVisibles = true
    },
    toHome() {
      this.$emit('updateDialogVisible')
    },
    updateDialogVisible() {
      this.toHome()
    },
    beforeClose() {
      this.toHome()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  &__header {
    padding: 0;
  }
  &__body {
    padding: 0;
  }
}
</style>
